import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, mergeProps as _mergeProps, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card mb-3 border-0 bg-white" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "row g-3" }
const _hoisted_4 = { class: "col-md-3" }
const _hoisted_5 = { class: "col-md-5" }
const _hoisted_6 = { class: "col-md-4" }
const _hoisted_7 = { class: "magasin-card-header d-flex flex-wrap align-items-center gap-3" }
const _hoisted_8 = { class: "magasin-num" }
const _hoisted_9 = { class: "flex-grow-1 magasin-select" }
const _hoisted_10 = {
  key: 0,
  class: "text-danger small"
}
const _hoisted_11 = { class: "text-muted small" }
const _hoisted_12 = { class: "text-black" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "table-responsive" }
const _hoisted_15 = { class: "table align-middle mb-0 produits-table" }
const _hoisted_16 = { class: "text-muted" }
const _hoisted_17 = {
  key: 0,
  class: "text-danger small"
}
const _hoisted_18 = ["onUpdate:modelValue"]
const _hoisted_19 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_20 = ["onUpdate:modelValue"]
const _hoisted_21 = { class: "text-end fw-semibold text-black text-nowrap" }
const _hoisted_22 = { class: "text-center" }
const _hoisted_23 = ["disabled", "onClick"]
const _hoisted_24 = { class: "px-3 py-2" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = ["disabled"]
const _hoisted_27 = { class: "recap-bar d-flex flex-wrap align-items-center justify-content-between gap-3" }
const _hoisted_28 = { class: "text-muted small" }
const _hoisted_29 = {
  key: 0,
  class: "text-danger small"
}
const _hoisted_30 = { class: "d-flex flex-wrap align-items-center gap-3" }
const _hoisted_31 = { class: "text-end" }
const _hoisted_32 = { class: "recap-total" }
const _hoisted_33 = ["disabled"]
const _hoisted_34 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-1"
}
const _hoisted_35 = {
  key: 1,
  class: "fa fa-check me-1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createBlock(_component_Form, {
    onSubmit: _ctx.addApprovisionnement,
    "validation-schema": _ctx.approvisionnementSchema,
    "keep-values": _ctx.valuess,
    class: "appro-form"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[5] || (_cache[5] = _createElementVNode("h4", { class: "text-black fw-semibold mb-3" }, "Nouvel approvisionnement", -1)),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _cache[2] || (_cache[2] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-1" }, "Date", -1)),
              _createVNode(_component_Field, {
                name: "dateAppro",
                type: "date",
                value: _ctx.getCurrentDate(),
                class: "form-control shadow-none fs-md-15 text-black"
              }, null, 8, ["value"]),
              _createVNode(_component_ErrorMessage, {
                name: "dateAppro",
                class: "text-danger small"
              })
            ]),
            _createElementVNode("div", _hoisted_5, [
              _cache[3] || (_cache[3] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-1" }, [
                _createTextVNode(" Fournisseur "),
                _createElementVNode("span", { class: "text-muted fw-normal small" }, "(facultatif)")
              ], -1)),
              _createVNode(_component_Field, { name: "fournisseur" }, {
                default: _withCtx(({ field }) => [
                  _createVNode(_component_Multiselect, _mergeProps({
                    options: _ctx.fournisseurOptions,
                    searchable: true,
                    "track-by": "label",
                    label: "label",
                    modelValue: field.value,
                    "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                  }, field, { placeholder: "Sélectionner le fournisseur" }), null, 16, ["options", "modelValue", "onUpdate:modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_ErrorMessage, {
                name: "fournisseur",
                class: "text-danger small"
              })
            ]),
            _createElementVNode("div", _hoisted_6, [
              _cache[4] || (_cache[4] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-1" }, "Référence", -1)),
              _createVNode(_component_Field, {
                name: "refAppro",
                type: "text",
                class: "form-control shadow-none fs-md-15 text-black",
                placeholder: "Ex. BL-0042"
              }),
              _createVNode(_component_ErrorMessage, {
                name: "refAppro",
                class: "text-danger small"
              })
            ])
          ]),
          _createVNode(_component_Field, {
            name: "montantTotal",
            type: "hidden",
            modelValue: _ctx.montantTotal,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.montantTotal) = $event))
          }, null, 8, ["modelValue"])
        ])
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.magasins, (magasin, magasinIndex) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "card mb-3 border-0 bg-white magasin-card",
          key: magasinIndex
        }, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("span", _hoisted_8, _toDisplayString(magasinIndex + 1), 1),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_Multiselect, {
                options: _ctx.magasinOptionsPour(magasinIndex),
                searchable: true,
                "track-by": "label",
                label: "label",
                modelValue: magasin.magasin,
                "onUpdate:modelValue": ($event: any) => ((magasin.magasin) = $event),
                placeholder: "Choisir le magasin à approvisionner",
                onSelect: ($event: any) => (_ctx.selectMag(magasin.magasin, magasin))
              }, null, 8, ["options", "modelValue", "onUpdate:modelValue", "onSelect"]),
              (_ctx.tentative && magasin.magasin === '')
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, " Le magasin est obligatoire. "))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("span", _hoisted_11, [
              _createTextVNode(_toDisplayString(magasin.produits.length) + " produit" + _toDisplayString(magasin.produits.length > 1 ? 's' : '') + " · ", 1),
              _createElementVNode("strong", _hoisted_12, _toDisplayString(_ctx.formatMontant(_ctx.sousTotal(magasin))), 1)
            ]),
            (_ctx.magasins.length > 1)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "btn btn-link text-danger p-1",
                  title: "Retirer ce magasin",
                  onClick: ($event: any) => (_ctx.removeRowMagasin(magasinIndex))
                }, _cache[6] || (_cache[6] = [
                  _createElementVNode("i", { class: "fa fa-trash-o fs-5" }, null, -1)
                ]), 8, _hoisted_13))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("table", _hoisted_15, [
              _cache[8] || (_cache[8] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", { class: "col-num" }, "#"),
                  _createElementVNode("th", null, [
                    _createTextVNode("Produit "),
                    _createElementVNode("span", { class: "text-danger" }, "*")
                  ]),
                  _createElementVNode("th", { class: "col-qte" }, [
                    _createTextVNode("Quantité "),
                    _createElementVNode("span", { class: "text-danger" }, "*")
                  ]),
                  _createElementVNode("th", { class: "col-prix" }, "Prix de revient"),
                  _createElementVNode("th", { class: "col-montant text-end" }, "Montant"),
                  _createElementVNode("th", { class: "col-action" })
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(magasin.produits, (produit, produitIndex) => {
                  return (_openBlock(), _createElementBlock("tr", { key: produitIndex }, [
                    _createElementVNode("td", _hoisted_16, _toDisplayString(produitIndex + 1), 1),
                    _createElementVNode("td", null, [
                      _createVNode(_component_Multiselect, {
                        options: _ctx.produitOptionsPour(magasin, produitIndex),
                        searchable: true,
                        "track-by": "label",
                        label: "label",
                        modelValue: produit.produit,
                        "onUpdate:modelValue": ($event: any) => ((produit.produit) = $event),
                        placeholder: "Sélectionner le produit",
                        onSelect: ($event: any) => (_ctx.selectProd(produit.produit, produit))
                      }, null, 8, ["options", "modelValue", "onUpdate:modelValue", "onSelect"]),
                      (_ctx.tentative && produit.produit === '')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, " Le produit est obligatoire. "))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("td", null, [
                      _withDirectives(_createElementVNode("input", {
                        type: "number",
                        min: "1",
                        "onUpdate:modelValue": ($event: any) => ((produit.qtite) = $event),
                        class: _normalizeClass(['form-control shadow-none text-black', { 'is-invalid': _ctx.tentative && _ctx.validateRowProduit(produit.qtite) }]),
                        placeholder: "0"
                      }, null, 10, _hoisted_18), [
                        [_vModelText, produit.qtite]
                      ]),
                      (_ctx.tentative && _ctx.validateRowProduit(produit.qtite))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_19, " Quantité obligatoire. "))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("td", null, [
                      _withDirectives(_createElementVNode("input", {
                        type: "number",
                        min: "0",
                        "onUpdate:modelValue": ($event: any) => ((produit.prixRevient) = $event),
                        class: "form-control shadow-none text-black",
                        placeholder: "0"
                      }, null, 8, _hoisted_20), [
                        [_vModelText, produit.prixRevient]
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_21, _toDisplayString(_ctx.formatMontant(produit.montant)), 1),
                    _createElementVNode("td", _hoisted_22, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-link text-muted p-1 btn-retirer",
                        title: "Retirer ce produit",
                        disabled: magasin.produits.length === 1,
                        onClick: ($event: any) => (_ctx.removeRowProduit(magasinIndex, produitIndex))
                      }, _cache[7] || (_cache[7] = [
                        _createElementVNode("i", { class: "fa fa-times" }, null, -1)
                      ]), 8, _hoisted_23)
                    ])
                  ]))
                }), 128))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-link p-0 fw-semibold lien-ajout",
              onClick: ($event: any) => (_ctx.addRowProduit(magasinIndex))
            }, _cache[9] || (_cache[9] = [
              _createElementVNode("i", { class: "fa fa-plus me-1" }, null, -1),
              _createTextVNode("Ajouter un produit ")
            ]), 8, _hoisted_25)
          ])
        ]))
      }), 128)),
      _createElementVNode("button", {
        type: "button",
        class: "btn w-100 mb-3 ajout-magasin",
        disabled: _ctx.magasins.length >= _ctx.magasinOptions.length,
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addRowMagasin()))
      }, _cache[10] || (_cache[10] = [
        _createElementVNode("i", { class: "fa fa-plus-circle me-1" }, null, -1),
        _createTextVNode("Approvisionner un autre magasin ")
      ]), 8, _hoisted_26),
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.magasins.length) + " magasin" + _toDisplayString(_ctx.magasins.length > 1 ? 's' : '') + " · " + _toDisplayString(_ctx.nbProduits) + " produit" + _toDisplayString(_ctx.nbProduits > 1 ? 's' : ''), 1),
          (_ctx.tentative && _ctx.messageManquant)
            ? (_openBlock(), _createElementBlock("div", _hoisted_29, _toDisplayString(_ctx.messageManquant), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("div", _hoisted_31, [
            _cache[11] || (_cache[11] = _createElementVNode("div", { class: "text-muted small text-uppercase" }, "Total", -1)),
            _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.formatMontant(_ctx.montantTotal)), 1)
          ]),
          _createVNode(_component_router_link, {
            to: "/approvisionnements/liste-approvisionnements",
            class: "btn btn-light border"
          }, {
            default: _withCtx(() => _cache[12] || (_cache[12] = [
              _createTextVNode(" Annuler ")
            ])),
            _: 1
          }),
          _createElementVNode("button", {
            class: "btn btn-primary",
            type: "submit",
            disabled: _ctx.enCours
          }, [
            (_ctx.enCours)
              ? (_openBlock(), _createElementBlock("span", _hoisted_34))
              : (_openBlock(), _createElementBlock("i", _hoisted_35)),
            _cache[13] || (_cache[13] = _createTextVNode("Enregistrer "))
          ], 8, _hoisted_33)
        ])
      ])
    ]),
    _: 1
  }, 8, ["onSubmit", "validation-schema", "keep-values"]))
}